import React from 'react';

type InputProps = {
  name: string;
  isDisabled?: boolean;
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  isTextArea?: boolean;
  isRequired?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  autoComplete?: string;
  onClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void
  autoFocus?: boolean
};

const inputClasses =
  'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500';

const Input = (props: InputProps) => {
  return props.isTextArea ? (
    <textarea
      id={props.name}
      name={props.name}
      className={inputClasses}
      placeholder={props.placeholder}
      required={props.isRequired}
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
    />
  ) : (
    <input
      type={props.type || 'text'}
      id={props.name}
      name={props.name}
      className={inputClasses}
      placeholder={props.placeholder}
      required={props.isRequired}
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      autoComplete={props.autoComplete || 'off'}
      onClick={props.onClick}
      autoFocus={props.autoFocus}
    />
  );
};

export default Input;
